import { McpServerConnectionSafe } from '@vivport/backend/types';

export type McpProbeState = {
  kind: 'ok' | 'error';
  text: string;
};

export function describePinResult(connection: McpServerConnectionSafe): string {
  if (connection.pinnedTools.length === 0) {
    return `Pinned no tools for '${connection.name}'.`;
  }
  return `Pinned ${connection.pinnedTools.length} tool(s) for '${connection.name}': ${connection.pinnedTools
    .map((tool) => tool.name)
    .join(', ')}`;
}
